import { has } from 'lodash';
export class TodayUsedCntMap {
    constructor() {
        this.usedMap = {};
    }
    init() {
        this.usedMap = {};
    }
    initOne(couponId, cnt = 0) {
        if (!this.usedMap[couponId]) {
            this.usedMap[couponId] = cnt;
        }
        else {
            this.usedMap[couponId] = cnt;
        }
    }
    increase(couponId, cnt = 1) {
        this.usedMap[couponId] += cnt;
    }
    get(couponId) {
        return this.usedMap[couponId];
    }
    has(couponId) {
        return has(this.usedMap, couponId);
    }
}
export default new TodayUsedCntMap();
//# sourceMappingURL=todayUsedCntMap.js.map